export const getThemeCode = (state) => {
    return state.appState.theme_name ? state.appState.theme_name : 'default_theme';
}
export const getLogo = (state) => state.appState.logo;
export const getLogoNegative = (state) => state.appState.logo_negative;
export const getFavicon = (state) => state.appState.favicon;